import React from 'react'
import { LocalizedText, NavbarItem } from 'labguard-cdk'
import { PowerOffIcon } from 'src/components/common'
import { useLogout } from 'src/hooks'

export default function LogoutNavbarItem(props) {
  const onClick = useLogout()
  return <NavbarItem onClick={onClick} icon={PowerOffIcon} tooltip={<LocalizedText id="WEB_LOGOUT" />} {...props} />
}
